/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ResolvedScorecardSetResolvedFrom } from './resolvedScorecardSetResolvedFrom';
import type { ScorecardDefinitionOut } from './scorecardDefinitionOut';

export interface ResolvedScorecardSet {
  resolved_from: ResolvedScorecardSetResolvedFrom;
  can_edit: boolean;
  definitions: ScorecardDefinitionOut[];
}
